import { render, staticRenderFns } from "./ApplyNotarization.vue?vue&type=template&id=a10065ba&scoped=true&"
import script from "./ApplyNotarization.vue?vue&type=script&lang=js&"
export * from "./ApplyNotarization.vue?vue&type=script&lang=js&"
import style0 from "./ApplyNotarization.vue?vue&type=style&index=0&id=a10065ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10065ba",
  null
  
)

export default component.exports